import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalNotifications, withProviders } from '../../../modules/core/components';
export default angular
    .module('doxy.common.components.reactGlobalNotifications', [])
    .component('reactGlobalNotifications', {
    template: `<div></div>`,
    bindings: {},
    controller: function ($element) {
        ReactDOM.render(React.createElement(withProviders(GlobalNotifications)), $element[0]);
    }
}).name;
